import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import { IconButtonComponent } from '../button/button.component';
import { Icons } from '../icon/constants/icons.constants';
import { IconComponent } from '../icon/icon.component';
import { LinkComponent } from '../link/link.component';
import { MenuTriggerDirective } from '../menu/directives/trigger/trigger.directive';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'nw-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IconComponent,
        IconButtonComponent,
        MenuTriggerDirective,
        MenuComponent,
        LinkComponent
    ],
    encapsulation: ViewEncapsulation.None
})
export class TooltipComponent implements OnChanges {
    @Input() icon: Icons.Type = 'circle-info';
    @Input() content?: string;
    @Input() panelClass?: string[];
    @Input() xPosition: 'before' | 'after' | 'center' = 'center';
    @Input() yPosition: 'above' | 'below' = 'above';
    @Input() type: 'link' | 'icon' = 'icon';
    @Input() linkLabel?: string = '';

    public class: string[] = ['tooltip-overlay-pane'];

    public ngOnChanges({ panelClass }: SimpleChanges): void {
        if (panelClass?.currentValue) {
            this.class = [...new Set([...this.class, ...(this.panelClass ?? [])])];
        }
    }
}
